import React, { useEffect, useState } from 'react';
import './LoadingScreen.css';

const TIPS = [
  'Загружаем…',
  'Ещё секунда…',
  'Почти готово…',
];

/**
 * Soft branded loader. Appears only after a short delay to avoid flash
 * on fast auth/navigation.
 */
const LoadingScreen = ({ tip, delayMs = 220 }) => {
  const [visible, setVisible] = useState(delayMs <= 0);
  const [tipIndex, setTipIndex] = useState(0);

  useEffect(() => {
    if (delayMs <= 0) return undefined;
    const timer = window.setTimeout(() => setVisible(true), delayMs);
    return () => window.clearTimeout(timer);
  }, [delayMs]);

  useEffect(() => {
    if (!visible || tip) return undefined;
    const timer = window.setInterval(() => {
      setTipIndex((current) => (current + 1) % TIPS.length);
    }, 2200);
    return () => window.clearInterval(timer);
  }, [tip, visible]);

  return (
    <div className={`loading-screen${visible ? ' is-visible' : ''}`} role="status" aria-live="polite">
      <div className="loading-panel">
        <div className="loading-mark" aria-hidden="true">
          <img src="/pwa-icon-192.png" alt="" />
        </div>
        <div className="loading-ring" aria-hidden="true" />
        <div className="loading-copy">
          <p className="loading-title">BillingService</p>
          <p className="loading-subtitle">{tip || TIPS[tipIndex]}</p>
        </div>
      </div>
    </div>
  );
};

export default LoadingScreen;
